/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import Vue from 'vue';
import Router from 'vue-router';

import {TextEncoder, TextDecoder} from "text-encoding";

import Auth from '@okta/okta-vue';

import Home from '../components/Home';
import TravelCalcForm from '../components/travel-calculator/TravelCalcForm';
import LoginComponent from '../components/Login';
import EventPay from "../components/travel-calculator/EventPay";
import PayComplete from "../components/travel-calculator/PayComplete";
import GeneralLivingForm from "../components/general-living-calculator/GeneralLivingForm";
import GeneralLivingContribute from "../components/general-living-calculator/GeneralLivingContribute";
import GeneralPayComplete from "../components/general-living-calculator/GeneralPayComplete";
import ProfileComponent from '../components/Profile';
import AdminComponent from "../components/Admin";
import MessagesComponent from '../components/Messages';
import EventComponent from "../components/Event";
import DirectForm from "../components/direct-contribute/DirectForm.vue";
import DirectCarbonPay from "../components/direct-contribute/DirectCarbonPay.vue";

import sampleConfig from '../config';

import store from "../store";
import AuthCallback from "../components/AuthCallback";

if (typeof window.TextEncoder !== 'function') {
    window.TextEncoder = TextEncoder;
    window.TextDecoder = TextDecoder;
}

Vue.use(Router);
Vue.use(Auth, sampleConfig.oidc);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: "home",
            component: Home
        },
        {
            path: '/login',
            component: LoginComponent
        },
        {
            path: '/travel',
            component: TravelCalcForm
        },
        {
            path: '/travel/eventpay',
            component: EventPay
        },
        {
            path: '/travel/paycomplete',
            component: PayComplete
        },
        {
            path: '/living',
            component: GeneralLivingForm
        },
        {
            path: '/living/contribute',
            component: GeneralLivingContribute
        },
        {
            path: '/living/complete',
            component: GeneralPayComplete
        },
        {
            path: '/carbon',
            component: DirectForm
        },
        {
            path: '/carbonpay',
            component: DirectCarbonPay
        },
        {
            path: '/carbon/paycomplete',
            component: PayComplete
        },
        {
            path: '/implicit/callback',
            component: AuthCallback
        },
        {
            path: '/profile',
            component: ProfileComponent,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/admin",
            component: AdminComponent,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/event/:id?",
            component: EventComponent
        },
        {
            path: '/messages',
            component: MessagesComponent,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "*",
            beforeEnter(to, from, next) {
                next("/");
            }
        }
    ]
});

const onAuthRequired = async (from, to, next) => {
    const authenticated = await Vue.prototype.$auth.isAuthenticated();
    if (from.matched.some(record => record.meta.requiresAuth) && !authenticated) {
        // Navigate to custom login page
        next({path: '/login'});
    } else {
        next();
    }
};

const waitForStorage = async (to, from, next) => {
    await store.restored;
    next();
};

router.beforeEach(onAuthRequired);
router.beforeEach(waitForStorage);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js